import { ROLES as R } from "../core/roles";
import { everyoneBut, lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

// Category indexes (see CATEGORIES in LudDocuments.jsx) a limited role may see.
// Exported so the backend contract (lud-backend/utils/access/contract.json) carries the same limits.
export const CATEGORY_LIMITS = { [R.DM]: [4, 5], [R.MENU_SP]: [6] };

export const ludDocumentPermissions = {
  view: "ludDocument.view",
  manage: "ludDocument.manage",
  adminView: "ludDocument.admin.view",
  permanentDelete: "ludDocument.permanentDelete",
  historyView: "ludDocument.history.view",
  category: { view: "ludDocument.category.view" },
};

export const ludDocumentGrants = {
  // upload, edit, replace and archive documents of a restaurant (backend: WRITE_ROLES in ludDocumentsHelpers)
  "ludDocument.manage": rule(lud(R.DM, R.DMM, R.AM), { scope: SCOPES.RESTAURANT }),
  "ludDocument.view": rule(lud(R.FA, R.DM, R.DMM, R.AM, R.MENU_SP, R.STORE_L, R.STORE, R.NEW)),
  // overview, alerts / metrics / admin columns: every role except the restaurant
  // itself (store, storeL); restored for dm and menuSp in batch 1 (NA-007)
  "ludDocument.admin.view": rule(everyoneBut(R.STORE, R.STORE_L)),
  // ceo-level and dmm, and the restaurant being edited must be in the user's scope
  "ludDocument.permanentDelete": rule(lud(R.DMM), { scope: SCOPES.RESTAURANT }),
  "ludDocument.history.view": rule(lud(R.DMM)),
  // resource: { categoryIndex } - dm sees categories 4-5, menuSp sees 6
  "ludDocument.category.view": rule([...everyoneBut(), R.NEW], {
    when: ({ role, resource }) => {
      const limit = CATEGORY_LIMITS[role];
      return !limit || limit.includes(resource?.categoryIndex);
    },
  }),
};
